import axios from 'axios'

const API_DOMAIN = process.env.VUE_APP_NANO_BANANA_SERVICE
const NANO_BANANA_X_API_KEY = process.env.VUE_APP_NANO_BANANA_X_API_KEY

/*** Create a custom instance of axios ***/
const http = axios.create({
  baseURL: `${API_DOMAIN}`,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  }
})

/*** Add interceptor to modify request config ***/
http.interceptors.request.use(async config => {
  config.headers = {
    ...config.headers,
    'x-api-key': NANO_BANANA_X_API_KEY, // Add the API key to every request
    ...((config.data instanceof FormData) && { 'Content-Type': 'multipart/form-data' })
  };

  return config
})

/*** Add global error handling ***/
http.interceptors.response.use(null, error => {
  if (error.response) {
    switch (error.response.status) {
      default:
        console.error('Unexpected Error:', error.response.data)
        return Promise.reject(error)
    }
  }
})

export default {
  get: http.get,
  post: http.post,
  put: http.put,
  delete: http.delete
}
